// Stessi stili per l'anteprima e per il PDF WeasyPrint.
// Le colonne restano quelle della vista desktop, indipendenti dalla larghezza del foglio A4.
export const REFERTO_PRINT_CSS = `
.referto-sheet {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #212529;
  font-family: Arial, "Liberation Sans", Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.5;
}
.referto-sheet, .referto-sheet * { box-sizing: border-box; }
.referto-sheet h1,
.referto-sheet h2,
.referto-sheet h3,
.referto-sheet h6,
.referto-sheet p { margin-top: 0; }
.referto-sheet p { margin-bottom: 1rem; }
.referto-sheet h6 {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2;
}
.referto-sheet small { font-size: 0.875em; }
.referto-sheet hr {
  margin: 1rem 0;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

.referto-sheet .row {
  display: block !important;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
  font-size: 0;
}
.referto-sheet .row > * {
  display: inline-block !important;
  vertical-align: top;
  width: 100%;
  max-width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  font-size: 16px;
}
.referto-sheet .col-12 { width: 100% !important; max-width: 100% !important; }
.referto-sheet .col-md-4 { width: 33.33333333% !important; max-width: 33.33333333% !important; }
.referto-sheet .col-md-6 { width: 50% !important; max-width: 50% !important; }
.referto-sheet .col-md-8 { width: 66.66666667% !important; max-width: 66.66666667% !important; }
.referto-sheet .col-lg-3 { width: 25% !important; max-width: 25% !important; }
.referto-sheet .row > * > div[style*="height: 100%"],
.referto-sheet .row > * > div[style*="height:100%"] {
  height: auto !important;
}

.referto-sheet .d-block { display: block !important; }
.referto-sheet .d-flex { display: block !important; font-size: 0; }
.referto-sheet .d-flex > div { display: inline-block; vertical-align: top; font-size: 16px; }
.referto-sheet .d-flex.justify-content-between > div:first-child { width: 72%; }
.referto-sheet .d-flex.justify-content-between > div:last-child { width: 28%; text-align: right; }
.referto-sheet .text-center { text-align: center !important; }
.referto-sheet .text-md-end { text-align: right !important; }
.referto-sheet .text-muted { color: #6c757d !important; }
.referto-sheet .text-white { color: #fff !important; }
.referto-sheet .text-uppercase { text-transform: uppercase !important; }

.referto-sheet .mt-1 { margin-top: 0.25rem !important; }
.referto-sheet .mt-3 { margin-top: 1rem !important; }
.referto-sheet .mt-5 { margin-top: 3rem !important; }
.referto-sheet .mb-0 { margin-bottom: 0 !important; }
.referto-sheet .mb-1 { margin-bottom: 0.25rem !important; }
.referto-sheet .mb-2 { margin-bottom: 0.5rem !important; }
.referto-sheet .mb-3 { margin-bottom: 1rem !important; }
.referto-sheet .mb-3,
.referto-sheet .mb-4 {
  display: block;
  box-decoration-break: clone;
}
.referto-sheet .mb-3 {
  break-inside: avoid;
  page-break-inside: avoid;
}
.referto-sheet .mb-4 {
  margin-bottom: 1.5rem !important;
  break-inside: avoid;
  page-break-inside: avoid;
}
.referto-sheet .ms-1 { margin-left: 0.25rem !important; }
.referto-sheet .me-2 { margin-right: 0.5rem !important; }
.referto-sheet .my-2 { margin-top: 0.5rem !important; margin-bottom: 0.5rem !important; }
.referto-sheet .p-4 { padding: 1.5rem !important; }

.referto-sheet .card {
  display: block;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.175);
  border-radius: 0.375rem;
}
.referto-sheet .card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background-color: rgba(33, 37, 41, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.175);
}
.referto-sheet .card-header:first-child {
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}
.referto-sheet .card-body {
  display: block;
  padding: 1rem;
}
.referto-sheet .bg-primary { background-color: #0d6efd !important; }
.referto-sheet .bg-light { background-color: #f8f9fa !important; }
.referto-sheet .bg-success { background-color: #198754 !important; }
.referto-sheet .bg-warning { background-color: #ffc107 !important; }
.referto-sheet .border-0 { border: 0 !important; }
.referto-sheet .border-primary { border-color: #0d6efd !important; }
.referto-sheet .badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
}
.referto-sheet .btn {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  background-color: transparent;
}
.referto-sheet .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}
.referto-sheet .btn-outline-primary {
  color: #0d6efd;
  border-color: #0d6efd;
}

.referto-sheet div[style*="248, 249, 250"],
.referto-sheet div[style*="#f8f9fa"],
.referto-sheet div[style*="24, 145, 166"],
.referto-sheet div[style*="#1891a6"] {
  break-inside: avoid;
  page-break-inside: avoid;
}
`;
